import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import { getUserLanguage, requirements } from "../../utils/Utils";
import { setAlert } from "../../../actions/alertActions";
import { updatePasswordResetStatus } from "../../../actions/accountActions";

import "../../../styles/components/account/recoverPassword/RecoverPassword.scss";
import "react-phone-input-2/lib/style.css";
import evio from "../../../styles/images/evio.svg";

class RecoverPassword extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      email: "",
      code: "",

      password: "",
      confirmPassword: "",

      loading: false,
      sentEmail: false,
    };

    this.handleInputValueChange = this.handleInputValueChange.bind(this);
    this.validatePasswords = this.validatePasswords.bind(this);
    this.handleRecoverPassword = this.handleRecoverPassword.bind(this);
    this.resend = this.resend.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.safeSetState({
      country: getUserLanguage(),
    });
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting.");
  }

  handleInputValueChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  validatePasswords() {
    const { password, confirmPassword } = this.state;
    const passwordsMatch =
      password !== "" && confirmPassword !== "" && password === confirmPassword;
    const requirementsMet = requirements.every((req) => req.test(password));
    return !(passwordsMatch && requirementsMet);
  }

  handleRecoverPassword(e) {
    e.preventDefault();
    const elements = e.target.elements;
    const email = this.state.email.trim();

    //if (!this.state.sentEmail)
    if (!this.props.isPasswordCodeSent) {
      this.safeSetState(
        {
          loading: true,
        },
        () => {
          const post = {
            email,
          };

          axios
            .post("/api/company/recover_password", post, {
              cancelToken: new CancelToken((c) => (this.cancel = c)),
            })
            .then((res) => {
              if (res.status === 200) {
                this.safeSetState(
                  {
                    loading: false,
                  },
                  () => {
                    this.props.updatePasswordResetStatus({
                      tempEmail: email,
                      isPasswordCodeSent: true,
                    });
                  }
                );
              }
            })
            .catch((err) => {
              if (
                err &&
                err.response &&
                err.response.data &&
                err.response.data.code
              ) {
                if (err.response.data.code === "server_user_not_found_email") {
                  window.location.assign("../recoverPassword");
                  this.props.updatePasswordResetStatus({
                    tempEmail: "",
                    isPasswordCodeSent: false,
                  });
                }

                setAlert(I18n.t(err.response.data.message), "danger");
                window.location.assign("../recoverPassword");
              } else if (axios.isCancel(err)) console.log("axios", err);
              else console.log(err);
            });
        }
      );
    } else {
      const password = elements.password.value;
      const confirmPassword = elements.confirmPassword.value;
      if (password === "" || confirmPassword === "") {
        this.props.setAlert(I18n.t("server_password_required"), "danger");
        return;
      }

      const put = {
        email: this.props.tempEmail,
        code: this.state.code,
        password: password,
      };

      axios
        .put("/api/company/recover_password", put, {
          cancelToken: new CancelToken((c) => (this.cancel = c)),
        })
        .then((res) => {
          if (res.status === 200) {
            this.props.updatePasswordResetStatus({
              tempEmail: "",
              isPasswordCodeSent: false,
            });
            this.props.setAlert(I18n.t("server_password_changed"), "primary");
            window.location.assign("../login");
          }
        })
        .catch((err) => {
          if (err.response.data)
            this.props.setAlert(I18n.t(err.response.data.message), "danger");
          if (axios.isCancel(err)) console.log("axios", err);
          else console.log(err);
        });
    }
  }

  resend(e) {
    e.preventDefault();

    this.safeSetState(
      {
        email: "",
      },
      () => {
        this.props.updatePasswordResetStatus({
          tempEmail: "",
          isPasswordCodeSent: false,
        });
      }
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  verificationCodeEmail(codeEmail) {
    if (this.props.isPasswordCodeSent) {
      return <Translate value="signUpVerification_subTitle" />;
    } else {
      if (!this.props.isPasswordCodeSent && !this.state.loading) {
        return <Translate value="forgotPassword_subTitle" />;
      } else {
        if (!this.props.isPasswordCodeSent && this.state.loading) {
          return <Translate value="signUpVerification_emailLoading" />;
        } else {
          return null;
        }
      }
    }
  }

  render() {
    return (
      <div id="recoverPassword" className="evio-container">
        <div className="sidemenu">
          <div className="logo-container">
            <img
              src={this.props.brand?.icons?.principalIcon || evio}
              alt={`${this.props.brand?.brandName} logo`}
            />
          </div>
          <div className="form-container">
            <form id="recover-form" onSubmit={this.handleRecoverPassword}>
              <div className="form-field column">
                <h3>
                  {this.props.isPasswordCodeSent ? (
                    <Translate value="forgotPasswordVerificationCode_title" />
                  ) : (
                    <Translate value="forgotPassword_title" />
                  )}
                </h3>
                <p>
                  {this.props.isPasswordCodeSent ? (
                    <Translate value="recoverPasswordLastStep" />
                  ) : !this.props.isPasswordCodeSent && !this.state.loading ? (
                    <Translate value="recoverPasswordFirstStep" />
                  ) : !this.props.isPasswordCodeSent && this.state.loading ? (
                    <Translate value="recoverPasswordLoadingStep" />
                  ) : null}
                </p>
              </div>
              {!this.props.isPasswordCodeSent && !this.state.loading ? (
                <div className="form-field">
                  <input
                    className="email-input"
                    type="text"
                    name="email"
                    placeholder={"email@example.com"}
                    value={this.state.email}
                    onChange={this.handleInputValueChange}
                    pattern="[a-z0-9._%\+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
                    required
                  />
                </div>
              ) : !this.props.isPasswordCodeSent && this.state.loading ? (
                <div className="loading-container">
                  <div className="loading-spinner">
                    <div className="generic-loading">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              ) : null}
              {this.props.isPasswordCodeSent && (
                <>
                  <div className="form-field column">
                    <input
                      className="code-input"
                      type="text"
                      name="code"
                      placeholder={I18n.t("componentVerificationCode_code")}
                      value={this.state.code}
                      onChange={this.handleInputValueChange}
                    />

                    {
                      <p>
                        <Translate value="componentVerificationCode_didnGetCode" />
                        <a
                          href="#resend"
                          onClick={this.resend}
                          className="link"
                        >
                          <Translate value="componentVerificationCode_resend" />
                        </a>
                      </p>
                    }
                  </div>
                  <div className="form-field">
                    <input
                      type="password"
                      name="password"
                      placeholder={I18n.t("forgotPassword_newPassword")}
                      value={this.state.password}
                      onChange={this.handleInputValueChange}
                    />
                  </div>
                  <div className="form-field">
                    <input
                      type="password"
                      name="confirmPassword"
                      placeholder={I18n.t("forgotPassword_confirmPassword")}
                      value={this.state.confirmPassword}
                      onChange={this.handleInputValueChange}
                    />
                  </div>
                  <div
                    className="passwordRequirements"
                    style={{ marginTop: "10px" }}
                  >
                    {requirements.map((requirement, index) => {
                      const isValid = requirement.test(this.state.password);
                      return (
                        <div
                          key={index}
                          className={`requirement ${
                            isValid ? "valid" : "invalid"
                          }`}
                        >
                          <span className="conditionsIcons">
                            {isValid ? "✔" : "✘"}
                          </span>
                          {I18n.t(requirement.text)}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </form>
          </div>
          <div className="footer-container">
            {this.props.isPasswordCodeSent ? (
              <button
                type="submit"
                form="recover-form"
                disabled={this.validatePasswords()}
              >
                <Translate value="componentButton_verify" />
              </button>
            ) : (
              <button type="submit" form="recover-form">
                <Translate value="componentButton_next" />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isPasswordCodeSent: state.account.isPasswordCodeSent,
  tempEmail: state.account.tempEmail,
  brand: state.app.brand,
});

export default connect(mapStateToProps, {
  setAlert,
  updatePasswordResetStatus,
})(RecoverPassword);
